import { render, staticRenderFns } from "./CampaignHeader.vue?vue&type=template&id=18469461&"
import script from "./CampaignHeader.vue?vue&type=script&lang=js&"
export * from "./CampaignHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports